var exports = {
  "h": "suggestion__g-7Pdj",
  "sp": "suggestionPending__7pZryI",
  "fP": "suggestionError__weleep",
  "b9": "suggestionErrorTitle__MqcBTn",
  "gy": "suggestionApplied__cL4VMQ",
  "jR": "suggestionAppliedText__7tnHk9",
};

module.exports = exports;
